export interface IAppMenuRoute {
  name: string;
  link: string;
  showInSubheader?: boolean;
  showInMenu?: boolean;
}

export const APP_MENU_ROUTES: ReadonlyArray<IAppMenuRoute> = [
  { name: 'Esteira de Apuração', link: '/esteira-apuracao' },
  { name: 'Faturamento dos Contratos', link: '/faturamento-contratos' },
  { name: 'Repasse de Comissão', link: '/repasse-comissao' },
  { name: 'Comissão de Faturamento', link: '/comissao-faturamento' },
  { name: 'Configurações', link: '/configuracoes' },
  { name: 'Configuração NF', link: '/configuracao-nf' },
  { name: 'Códigos de Serviço e Tributação', link: '/codigos-servico' },
  { name: 'Detalhes do Contrato', link: '/contratos', showInMenu: false },
  { name: 'Sair', link: '/sair', showInSubheader: false }
];
